import KunLoading54 from './src/index'

KunLoading54.install = function (Vue) {
	Vue.component(KunLoading54.name, KunLoading54);
}

export default KunLoading54;
